// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import * as serviceSelectors from './selectors';
import * as serviceActions from './actions';
import * as ServiceIcons from './Icons';

import ArchiveIcon from '@material-ui/icons/Archive';
import UnarchieveIcon from '@material-ui/icons/Unarchive';
import * as Formatters from '../ui/Formatters';
import * as MessageFormat from './MessageFormat';
import LinkedText from '../ui/LinkedText';

const styles = theme => ({
  ...MessageFormat.styles(theme),
});


/*
 * Format for an outcall
 */
class OutcallFormat extends Component {

  formatDuration = (durationInSeconds, round) => {
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = Math.floor(durationInSeconds % 60);

    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');

    return `${formattedMinutes}:${formattedSeconds}`;
  }

  render() {
    /* eslint-disable */
    const { classes, message, toggleFollowup, archiveMessage, 
      unarchiveMessage, markMessageRead, unmarkMessageRead,
      setActivityDetailOpen, newContact } = this.props;

    return (
      <div className={classes.formatTop}>
        <div className={classes.messageSender}>
          Outcall to  <LinkedText onClick={this.props.openContactLink}
                                  value={Formatters.formatPhoneNumber(message.outcallNumber)}/> by {message.taskUser}
        </div>
        <div className={classes.taken}>
          {Formatters.formatDateTime(message.taken)}
        </div>
        {/* <div className={classes.taken}>
          Reference ID: {message.messageId}
        </div>
        <div className={classes.taken}>
          Contact Description: {message.contactDescription}
        </div> */}

        <MuiCore.Grid item>
          <MuiCore.Grid container style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', marginTop: 10}}>
              <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: 'pointer'}} onClick={() => {
                newContact(message.outcallNumber)
              }}>
                <MuiCore.Grid item style={{height: 50, width: 50, marginLeft: 10}}>
                  <MuiCore.Grid item style={{verticalAlign: 'middle', height: '100%'}}>
                    <ServiceIcons.SaveContactIcon fontSize='medium' style={{marginTop: 13, color:'#122457'}}/>
                  </MuiCore.Grid>
                </MuiCore.Grid>
                <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10}}>
                  Save contact
                </MuiCore.Typography>
              </MuiCore.Grid>
              <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: 'pointer'}} onClick={() => {
                if(message.read){
                  unmarkMessageRead(message.messageId)
                }else{
                  markMessageRead(message.messageId)
                }
                setActivityDetailOpen(false);
              }}>
                <MuiCore.Grid item style={{backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: 40, height: 50, width: 50, marginLeft: 10}}>
                  <MuiCore.Grid item style={{verticalAlign: 'middle', height: '100%'}}>
                    <MuiCore.SvgIcon xmlns="http://www.w3.org/2000/svg" width="31.5" height="21" viewBox="0 0 31.5 21" style={{color: '#122457', marginTop: 13}}>
                      <path d="M.6.99V16.571L11.439,9.345ZM16.294,13.3l-3.726-2.823L.6,18.49V21.2H32.1V18.49L19.907,10.361Zm15.694,3.387V1.1L21.149,9.458ZM16.294,11.265,30.52.2H2.068Z" transform="translate(-0.6 -0.2)"/>
                    </MuiCore.SvgIcon>
                  </MuiCore.Grid>
                </MuiCore.Grid>
                <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10}}>
                  {message.read ? 'Mark unread' : 'Mark read'}
                </MuiCore.Typography>
              </MuiCore.Grid>
              <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: 'pointer'}} onClick={() => {
                if(message.archived){
                  unarchiveMessage(message.messageId);
                }else {
                  archiveMessage(message.messageId);
                }
                setActivityDetailOpen(false);
                }}>
                <MuiCore.Grid item style={{backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: 40, height: 50, width: 50}}>
                  <MuiCore.Grid item style={{verticalAlign: 'middle', height: '100%'}}>
                    {message.archived ? <UnarchieveIcon fontSize='medium' style={{marginTop: 13, color:'#122457'}}/> : <ArchiveIcon color='#122457' fontSize='medium' style={{marginTop: 13, color:'#122457'}}/>}
                  </MuiCore.Grid>
                </MuiCore.Grid>
                <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10}}>
                {message.archived ? 'Unarchive': 'Archive'}
                </MuiCore.Typography>
              </MuiCore.Grid>
              <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: 'pointer'}} onClick={() => {
                  this.props.openAssist(message);
                }}>
                <MuiCore.Grid item style={{backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: 40, height: 50, width: 50}}>
                  <MuiCore.Grid item style={{verticalAlign: 'middle', height: '100%'}}>
                    <ServiceIcons.AssistIcon fontSize='medium' style={{marginTop: 13}}/>
                  </MuiCore.Grid>
                </MuiCore.Grid>
                <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10}}>
                  Assist
                </MuiCore.Typography>
              </MuiCore.Grid>
              <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: 'pointer'}} onClick={() => {
                toggleFollowup(message, true)
                }}>
                <MuiCore.Grid item style={{backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: 40, height: 50, width: 50}}>
                  <MuiCore.Grid item style={{verticalAlign: 'middle', height: '100%'}}>
                    <ServiceIcons.FollowupIcon style={{color: '#122457', marginTop: 13}} followup={message.followup}/>
                  </MuiCore.Grid>
                </MuiCore.Grid>
                <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10}}>
                  Follow Up
                </MuiCore.Typography>
              </MuiCore.Grid>
            </MuiCore.Grid>
          </MuiCore.Grid>
        
        <MuiCore.Divider style={{marginTop: 20, marginBottom: 10}}/>

        <div className={classes.sectionHeader}>
          Call Details
        </div>
        
        <MuiCore.Grid>
          <MuiCore.Grid item>
            <div className={classes.fieldData}>
              Called From: <LinkedText value={Formatters.formatPhoneNumber(message.outcallSourceNumber)}
                          onClick={this.props.openContactLink}/>
            </div>
            {/* <div className={classes.fieldData}>
              <LinkedText value={Formatters.formatPhoneNumber(message.outcallSourceNumber)}
                          onClick={this.props.openContactLink}/>
            </div> */}
          </MuiCore.Grid>
          {/* <MuiCore.Grid item>
            <div className={classes.fieldData}>
              Call Start: {Formatters.formatDateTime(message.taskStartTime)}
            </div>
          </MuiCore.Grid> */}
          <MuiCore.Grid item xs={12} sm={6}>
            <div className={classes.fieldData}>
              Duration: {this.formatDuration(message.callLengthInSeconds)}
            </div>
          </MuiCore.Grid>
        </MuiCore.Grid>

        <MessageFormat.MessageStatus
          message={message}
          sectionHeaderClass={classes.sectionHeader}
          fieldLabelClass={classes.fieldLabel}
          fieldDataClass={classes.fieldData}/>
        
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    message : serviceSelectors.getMessage(state),
  });
};

const mapDispatchToProps = {
  openContactLink : serviceActions.openContactLink,
  toggleFollowup: serviceActions.toggleFollowup,
  openAssist : serviceActions.openAssist,
  archiveMessage : serviceActions.archiveMessage,
  unarchiveMessage : serviceActions.unarchiveMessage,
  markMessageRead : serviceActions.markMessageRead,
  unmarkMessageRead : serviceActions.unmarkMessageRead,
  setActivityDetailOpen : serviceActions.setActivityDetailOpen,
  newContact : serviceActions.newContact,
};

export default connect(mapStateToProps,
                       mapDispatchToProps)(withStyles(styles)(OutcallFormat));

